import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
} from '@mui/material';

const Testing = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      {/* Hero Section */}
      <Container maxWidth="lg">
        <Box sx={{ pt: 6, pb: 4, textAlign: 'center' }}>
          <Typography
            component="h1"
            variant="h1"
            gutterBottom
            sx={{
              fontWeight: 800,
              background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #10b981 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              mb: 2,
              animation: 'fadeInUp 1s ease-out',
              '@keyframes fadeInUp': {
                from: {
                  opacity: 0,
                  transform: 'translateY(30px)',
                },
                to: {
                  opacity: 1,
                  transform: 'translateY(0)',
                },
              },
            }}
          >
            🧪 Testing Page
          </Typography>
          <Typography
            component="h2"
            variant="h4"
            color="text.secondary"
            sx={{ 
              mb: 4, 
              maxWidth: '700px', 
              mx: 'auto',
              fontWeight: 400,
              lineHeight: 1.5,
              animation: 'fadeInUp 1s ease-out 0.2s both',
            }}
          >
            Testing the pinned messages feature in Discord chat iframe.
          </Typography>

          {/* Live Demo Section with Pinned Messages */}
          <Box sx={{ 
            mb: 6,
            animation: 'fadeInUp 1s ease-out 0.4s both',
          }}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                mx: 'auto',
                maxWidth: '1000px',
                bgcolor: 'background.paper',
                borderRadius: '20px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                background: 'linear-gradient(145deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.9) 100%)',
                backdropFilter: 'blur(20px)',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
                  borderColor: 'rgba(99, 102, 241, 0.3)',
                },
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  height: '600px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '2px solid rgba(99, 102, 241, 0.2)',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    borderColor: 'rgba(99, 102, 241, 0.5)',
                    boxShadow: '0 0 30px rgba(99, 102, 241, 0.2)',
                  },
                }}
              >
                <iframe
                  src="https://wizcord.io/iframe?channelId=1390363767530848457&show_pinned=true"
                  width="100%"
                  height="100%"
                  style={{ border: 'none' }}
                  title="Discord Chat Demo with Pinned Messages"
                  allow="clipboard-write"
                />
              </Box>
              <Typography 
                variant="body2" 
                color="text.secondary" 
                sx={{ 
                  mt: 2, 
                  textAlign: 'center',
                  fontSize: '0.95rem',
                }}
              >
                📌 Discord channel with pinned messages feature enabled
              </Typography>
            </Paper>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Testing;